import React from 'react';
import { motion } from 'framer-motion';

const shimmerVariants = {
  animate: {
    backgroundPosition: ['200% 0', '-200% 0'],
    transition: {
      duration: 1.5,
      repeat: Infinity,
      ease: 'linear'
    }
  }
};

export const Skeleton = ({ className = '', variant = 'default' }) => {
  const baseStyles = 'bg-[#1e1e2e] rounded overflow-hidden relative';
  
  const variantStyles = {
    default: 'h-4 w-full',
    title: 'h-6 w-3/4',
    avatar: 'h-12 w-12 rounded-full',
    card: 'h-32 w-full rounded-xl',
    button: 'h-10 w-24 rounded-lg',
    price: 'h-8 w-32',
  };

  return (
    <motion.div
      className={`${baseStyles} ${variantStyles[variant]} ${className}`}
      variants={shimmerVariants}
      animate="animate"
      style={{
        background: 'linear-gradient(90deg, #1e1e2e 0%, #2a2a3a 50%, #1e1e2e 100%)',
        backgroundSize: '200% 100%'
      }}
    />
  );
};

export const CardSkeleton = () => (
  <div className="bg-[#12121a] border border-[#1e1e2e] rounded-2xl p-6 space-y-4">
    <Skeleton variant="title" />
    <Skeleton className="h-4 w-full" />
    <Skeleton className="h-4 w-5/6" />
    <div className="flex gap-3 pt-2">
      <Skeleton variant="button" />
      <Skeleton variant="button" />
    </div>
  </div>
);

export const PriceSkeleton = () => (
  <div className="flex flex-col items-center gap-2">
    <Skeleton className="h-6 w-8 rounded" />
    <Skeleton variant="price" />
    <Skeleton className="h-3 w-16" />
  </div>
);

// Pre-calculated heights for chart skeleton bars
const chartBarHeights = [45, 62, 38, 75, 52, 88, 42, 70, 55, 80, 48, 65];

export const ChartSkeleton = () => (
  <div className="h-[300px] bg-[#12121a] rounded-xl p-4">
    <div className="flex justify-between mb-4">
      <Skeleton className="h-8 w-48" />
      <Skeleton className="h-8 w-32" />
    </div>
    <div className="h-[calc(100%-3rem)] flex items-end gap-1">
      {chartBarHeights.map((height, i) => (
        <Skeleton 
          key={i} 
          className="flex-1 rounded-t" 
          style={{ height: `${height}%` }}
        />
      ))}
    </div>
  </div>
);

export default Skeleton;
